<!-- Grid template -->
<template>
  <div class="grid-wrapper centix-grid-loadmore">
    <div v-if="mobileView" class="grid-mobile">
      <!-- Table rows -->
      <a :href="getHref(entry)" class="grid-list-item" v-for="(entry, index) in innerRows" v-on:click="onRowClick($event, [entry, null])" v-bind:key="index">
        <template v-for="(column, index) in visibleColumns">
          <div class="row" v-bind:key="index" v-bind:style="getStyleForRow(entry)">
            <div class="col-4">
              <strong>{{ column | titleDescrCheck }}</strong>
            </div>
            <div class="col-8">
              <div v-if="column.ColumnType == 0" class="td" v-html="$options.filters.columnFormatter(entry, column)">
                <!-- Renders on v-bind html with a column filter (for computed fields) -->
              </div>
              <div v-if="column.ColumnType == 2" class="td">
                <img style="width: 60px;" class="img-fluid" v-bind:src="getObjectImageFromEntry(column, entry, column.MediaTypeID_Small)" data-toggle="popover" v-bind:data-content="getObjectPopOverImageHtml(column, entry, column.MediaTypeID_Large)" />
              </div>
            </div>
          </div>
        </template>
      </a>
    </div>

    <div v-else class="grid-table">
      <!-- Table heading -->
      <div class="tr th">
        <div class="head-wrap">
          <div
            v-if="multiSelect"
            class="td checkbox"
            style="width: 25px"
            v-on:click="$emit('all-select-toggled', true)">
            <input type="checkbox" value="selectAllCheckbox" :title="$t(notAllLoaded ? 'grid.rows_selected_checkbox' : 'grid.rows_selected_checkbox_2', { 0: selectedCount, 1: totalResultCount || 0 })" v-model="checkAllSelected">
          </div>

          <div
            v-bind:id="'col-title-'+index"
            class="td" 
            v-for="(column, index) in visibleColumns"
            v-on:click.self="setSortOption(column)"
            v-bind:style="{ 'width' : toPixels(column.ColumnWidth) }"
            v-bind:class="{ 'text-right' : (column.ColumnAlignment == 2), 'text-center' : (column.ColumnAlignment == 1)}"
            v-bind:draggable="!isGrowing"
            v-on:dragstart="onDragStart"
            v-on:dragover="onDragOver"
            v-on:drop="onDrop"
            v-on:dragend="onDragEnd"
            v-bind:holder-index="index"
            v-bind:key="index"
            data-toggle="tooltip"
            data-placement="top"
            v-bind:data-original-title="getTooltipTitle(column, index)">
            {{ column | titleDescrCheck }}
            <span class="arrow" v-bind:class="{ asc: isOrderingAsc(column.FieldName), dsc: isOrderingDesc(column.FieldName) }"></span>
            <div class="th-holder-handle" v-draggable.self="onColumnGrow" v-bind:holder-index="index"></div>
          </div>
        </div>

        <!-- Table search -->
        <div v-if="columnSearch" class="tsearch">
          <div v-if="multiSelect" class="td resetfilter" style="width: 25px">
            <!-- no checkbox on search -->
            <a class="reset-btn" v-bind:class="{ 'show' : showColumnResetButton }" v-on:click="resetColumnFilters" data-toggle="tooltip" data-placement="top" v-bind:title="$t('grid.reset_filters')"></a>
          </div>
          <div
            class="td"
            v-for="(column, index) in visibleColumns"
            v-bind:style="{ 'width' : toPixels(column.ColumnWidth) }"
            v-bind:holder-index="index"
            v-bind:key="index">
            <column-filter
              :column="column"
              :key="column.FieldName"
              @input="onReturn($event, column)"
              @filter-change="advancedFilterChange" />
          </div>
        </div>
      </div>

      <!-- Table rows -->
      <div
        class="tr"
        v-for="(entry, index) in innerRows"
        v-on:click.left="onRowClick($event, [entry, null])"
        v-on:contextmenu.prevent.stop="onRowRightClick($event, [entry, null], 'col')"
        v-bind:key="index"
        v-bind:style="getStyleForRow(entry)"
        @mouseover="onMouseOver(entry)">
        <div
          v-if="multiSelect"
          class="td checkbox"
          v-on:click.left.stop
          style="width: 25px"
          v-on:click.self="colCheckBoxUpdate(entry, !entry.selected,true)">
          <input type="checkbox" @mousedown="onMouseOver(entry, true)" v-model="rowMetaData[index].selected" @change="raiseSelectedChanged(true)" v-bind:value="entry.AutoID" />
        </div>
        <a :href="getHref(entry)" v-bind:style="getStyleForRow(entry)">
          <template v-for="(column, index) in visibleColumns">
            <div
              class="td"
              v-if="column.ColumnType == 0"
              v-bind:style="{ 'width' : toPixels(column.ColumnWidth) }"
              v-bind:class="{ selected : (isDraggingOverIndex == index), 'text-right' : (column.ColumnAlignment == 2), 'text-center' : (column.ColumnAlignment == 1) }"
              v-bind:key="index"
              v-on:dblclick="onDoubleClick($event, [entry,column])"
              v-on:contextmenu.prevent.stop="onRowRightClick($event, [entry,column], 'col')">
              <span v-if="isHTMLColumn(column)" v-html="$options.filters.columnFormatter(entry, column)" @click="execute($event, entry, column.Action)" :class="{ 'action' : (column.HasAction) }"></span>
              <span v-else @click="execute($event, entry, column.Action)" :class="{ 'action' : (column.HasAction) }">{{ $options.filters.columnFormatter(entry, column) }}&nbsp;</span>
            </div>
            <div
              class="td"
              v-if="column.ColumnType == 2 && column.ComputedFieldDictionaryType == 2"
              v-bind:style="{ 'width' : toPixels(column.ColumnWidth), 'height' : '60px' }"
              v-bind:class="{ selected : (isDraggingOverIndex == index)}"
              v-bind:key="index">
              <img style="width: 48px;" class="img-fluid" v-bind:src="getObjectImageFromEntry(column, entry, column.MediaTypeID_Small)" data-container="body" data-toggle="popover" v-bind:data-content="getObjectPopOverImageHtml(column, entry, column.MediaTypeID_Large)" />
            </div>
            <div
              class="td"
              v-if="column.ColumnType == 2 && column.ComputedFieldDictionaryType == 4"
              v-bind:style="{ 'width' : toPixels(column.ColumnWidth), 'height' : '60px' }"
              v-bind:class="{ selected : (isDraggingOverIndex == index)}"
              v-bind:key="index">
              <img style="width: 48px;" class="img-fluid" v-bind:src="getImageFromEntry(column, entry, 0)" data-toggle="popover" data-container="body" v-bind:data-content="getPopOverImageHtml(column, entry, 1)" />
            </div>
          </template>
        </a>
      </div>
    </div>

    <!-- Loading spinner (load more) -->
    <div
      :id="loadMoreDivID"
      v-if="((!showEmptyView && showLoadMore) || isLoading)"
      class="load-more-container text-center"
      v-on:click="loadMore">
      <div class="inner-container">
        <span>{{ $t('grid.busy_loading') }}</span>
        <loading-spinner v-bind:loading="true" />
      </div>
    </div>

    <!-- Empty view -->
    <div v-if="showEmptyView" class="empty-view">
      <h2 class="text-center">{{ $t('grid.no_results') }}</h2>
    </div>

  </div>
</template>

<script lang="js">
import lodashDebounce from 'lodash/debounce';
import lodashFind from 'lodash/find';
import gridbase from 'components/Grid/mixins/gridbase.js';
import utils from 'libs/utils';
import ColumnFilter from './Column/ColumnFilter.vue';

const ImageTypeEnum = {
  Thumbnail: 0,
  Large: 1
};

export default {
  mixins: [gridbase],
  components: {
    'column-filter': ColumnFilter
  },
  data: function () {
    return {
      mobileView: false
    };
  },
  methods: {
    getImageFromEntry (column, entry, type) {
      let image = entry[column.FieldName];
      let result = null;
      if (image != null) {
        if (type === ImageTypeEnum.Thumbnail) {
          result = image.Thumbnail;
        } else if (type === ImageTypeEnum.Large) {
          result = image.Large;
        }
      }
      if (!result) {
        result = column.NoImage;
      }
      return result;
    },
    getPopOverImageHtml (column, entry, type) {
      let width = column.SizeLarge[0];
      let height = column.SizeLarge[1];
      return this.getPopOverHtml(this.getImageFromEntry(column, entry, type), width, height);
    },
    getObjectImageFromEntry: function (column, entry, imagetype) {
      if (entry != null && imagetype != null) {
        var image = lodashFind(entry[column.FieldName], {
          ObjectImage_MediaTypeID: imagetype
        });
        if (image != null) {
          return image[column.Image_FieldName];
        }
        return null;
      }
    },
    getObjectPopOverImageHtml: function (column, entry, imagetype) {
      if (entry != null && imagetype != null && column != null) {
        var width = column.SizeLarge[0];
        var height = column.SizeLarge[1];
        return this.getPopOverHtml(this.getObjectImageFromEntry(column, entry, imagetype), width, height);
      }
    },
    getPopOverHtml (src, width, height) {
      return (
        '<img src="' +
        src +
        '" style="max-width: ' +
        width +
        'px; max-height: ' +
        height +
        'px;">'
      );
    },
    isColumnSearchDisabled (column) {
      return utils.isColumnSearchDisabled(column);
    },
    isHTMLColumn (column) {
      return this.isHTMLGrid || utils.isHTMLColumn(column);
    },
    calculateLayout: function () {
      this.mobileView = window.innerWidth < 768;
    },
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.calculateLayout();
    // Avoid costly calculations while the window size is in flux.
    $(window).on('resize', lodashDebounce(this.calculateLayout, 150));
  },
  beforeDestroy () {
    $('.img-fluid').popover('hide');
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';
$action: #64B5F6;
$sub200: #65636C;

.centix-grid-loadmore {
  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 0.66;
  }

  .arrow.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid $sub200;
  }

  .arrow.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid $sub200;
  }

  &.grid-wrapper {
    min-width: 100%;
    width: auto;
    display: inline-block;
  }

  .grid-table {
    .tr:nth-of-type(odd) {
      background-color: #F8F9FA;
    }

    .tr.th {
      color: $sub200;
      cursor: pointer;
      position: sticky;
      top: 0px;
      z-index: 2;
      font-weight: bold;

      .td {
        padding-top: 8px;
        padding-bottom: 8px;
      }

      .head-wrap {
        background: #fff;

        .td {
          padding-top: 12px;
          padding-bottom: 12px;
        }
      }
    }

    .tr {
      white-space: nowrap;
      position: relative;
      display: inline-block;
      min-width: 100%;
      font-size: 0;
      background: #fff;
      user-select: none;
      -webkit-user-drag: none;
    }

    .tr:not(.th):hover {
      background: #efefef;
      cursor: pointer;
    }

    .tr .td {
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
      position: relative;
      padding: 0.5em;
      vertical-align: middle;
      font-size: 12px;

      .action {
        color: $blue600;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }

    .tr .td.selected {
      border-left: 1px solid #007bff;
    }

    .tr .th-holder-handle {
      position: absolute;
      right: 0;
      top: 0;
      width: 10px;
      height: 100%;
      background-color: #fff;
      border-right: 1px solid #f2f4f6;
      cursor: e-resize;
    }

    .tsearch {
      background-color: #f2f4f6;
      z-index: 2;

      .resetfilter {
        padding-left: 10px;

        .reset-btn {
          display: none;
          width: 24px;
          height: 24px;
          background: url('../../assets/remove.png') no-repeat center right 12px;
          background-size: 12px 12px;

          &.show {
            display: block;
          }
        }
      }
    }

    .empty-view {
      min-height: 350px;
    }
  }

  input[type="checkbox"].form-check-input {
    margin-top: 0.3rem;
    margin-left: -1.25rem;
  }

  .grid-mobile>.grid-list-item {
    padding: 15px;
    text-decoration: none;
  }

  .grid-mobile>.grid-list-item:nth-of-type(even) {
    background-color: #f8f8f8;
  }

  ul.layout-list {
    padding: 0;
  }

  ul.layout-list li {
    padding: 8px;
    list-style: none;
  }

  ul.layout-list li.selected-layout {
    background-color: #007bff;
    color: #fff;
  }

  .tsearch .search-input {
    width: 100%;
  }

  .load-more-container {
    min-width: 100%;
    background-color: #efefef;
    padding: 3em;
    margin-top: 1em;

    span {
      font-size: 1.5em;
      color: #444;
    }

    .inner-container {
      width: 100vw;
    }
  }
}

.tooltip {
  font-size: 1em;
}
</style>
